/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { NB_AUTH_OPTIONS } from '../../../../../../node_modules/@nebular/auth/auth.options.js';
import { getDeepFromObject } from '../../helpers';


@Component({
	selector: 'ngx-request-password-page',
	templateUrl: './request-password.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRequestPasswordComponent {

	redirectDelay: number = 0;
	showMessages: any = {};
	strategy: string = '';

	submitted = false;
	errors: string[] = [];
	messages: string[] = [];
	user: any = {
		passwordReset: 1,
	};

	constructor(protected service: NbAuthService,
							@Inject(NB_AUTH_OPTIONS) protected options = {},
							protected cd: ChangeDetectorRef,
							protected router: Router) {

		this.redirectDelay = this.getConfigValue('forms.requestPassword.redirectDelay');
		this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
		this.strategy = this.getConfigValue('forms.requestPassword.strategy');

		console.log('stat', this.strategy)
	}

	requestPass(): void {
		this.errors = this.messages = [];
		this.submitted = true;

		this.service.requestPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
			this.submitted = false;
			if (result.isSuccess()) {
				this.messages = result.getMessages();
			} else {
				this.errors = result.getErrors();
			}

			const redirect = result.getRedirect();
			if (redirect) {
				setTimeout(() => {
					return this.router.navigateByUrl(redirect);
				}, this.redirectDelay);
			}
			this.cd.detectChanges();
		});
	}

	getConfigValue(key: string): any {
		return getDeepFromObject(this.options, key, null);
	}
}
